export default __webpack_public_path__ + "static/Aargau-27b2998b21c0a0e8e2b3273c6cde0632.jpg";